import { render, staticRenderFns } from "./Hotline_management.vue?vue&type=template&id=6843f76e"
import script from "./Hotline_management.vue?vue&type=script&lang=js"
export * from "./Hotline_management.vue?vue&type=script&lang=js"
import style0 from "./Hotline_management.vue?vue&type=style&index=0&id=6843f76e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports